import { useEffect, useRef, useState } from "react";
import "./RadioButton.scss";
import { DesignTheme } from "../../../App.GeneratedEnums";
import { createSpreadableBem } from "../../../Helpers/createBem";

interface Props {
  disabled?: boolean;
  checked?: boolean;
  onClick?: () => void;
  label: string;
  name: string;
  theme?: DesignTheme;
}

const RadioButton = ({
  disabled,
  checked,
  onClick,
  label,
  name,
  theme,
}: Props) => {
  const [focusAfterLoad, setFocusAfterLoad] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [retries, setRetries] = useState(0);
  const [disabledState, setDisabledState] = useState(disabled);

  useEffect(() => {
    if (disabledState) return;
    if (!focusAfterLoad) return;
    if (retries <= 0) return;
    window.setTimeout(() => {
      if (inputRef.current?.disabled) {
        setRetries(retries - 1);
      } else {
        inputRef.current?.focus();
        setRetries(0);
        setFocusAfterLoad(false);
      }
    }, 50);
  }, [focusAfterLoad, disabledState, retries]);

  useEffect(() => setDisabledState(disabled));
  const bem = createSpreadableBem("radio-button-norad");
  return (
    <label {...bem("", { "--theme-insight": theme === DesignTheme.Insight })}>
      <input
        ref={inputRef}
        type="radio"
        disabled={disabledState}
        checked={checked}
        onClick={() => onClick && onClick()}
        onChange={() => {
          setRetries(5);
          setFocusAfterLoad(true);
        }}
        name={name}
      />
      <span
        {...bem("__text", { "--theme-insight": theme === DesignTheme.Insight })}
      >
        {label}
      </span>
    </label>
  );
};
export default RadioButton;
